import { DELIVERY_STATE } from '@theailab-dev/parchment';
import type { DeliveryState } from '@theailab-dev/parchment';

export function getDeliveryStateLabel(state: DeliveryState | string): string {
  switch (state) {
    case DELIVERY_STATE.ORDERED:
      return '결제 전';
    case DELIVERY_STATE.PREPARING:
      return '배송 준비 중';
    case DELIVERY_STATE.SHIPPED:
      return '출고 완료';
    case DELIVERY_STATE.IN_TRANSIT:
      return '배송 중';
    case DELIVERY_STATE.DELIVERED:
      return '배송 완료';
    case DELIVERY_STATE.CANCELED:
      return '배송 취소';
    default:
      return typeof state === 'string' ? state || '-' : '-';
  }
}
